import { render, staticRenderFns } from "./MuseumSetting.vue?vue&type=template&id=b9ef4fee&"
import script from "./MuseumSetting.vue?vue&type=script&lang=js&"
export * from "./MuseumSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports